import {
  DateField,
  Datagrid,
  Edit,
  EditButton,
  Filter,
  List,
  Resource,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
} from "react-admin";

const Filters = (props) => (
  <Filter {...props}>
    <TextInput label="Packaging Reference" source="name" alwaysOn />
  </Filter>
);

const RetailPackagingList = (props) => (
  <List {...props} filters={<Filters />} bulkActionButtons={false}>
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="id" label="ID" />
      <TextField source="name" label="Packaging Reference" />
      <DateField source="createdAt" label="Created at" />
      <DateField source="updatedAt" label="Updated at" />
      <EditButton />
    </Datagrid>
  </List>
);

const ShowRetailPackaging = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <TextField source="name" label="Packaging Reference" />
      <DateField source="createdAt" label="Created at" />
      <DateField source="updatedAt" label="Updated at" />
    </SimpleShowLayout>
  </Show>
);

const EditRetailPackaging = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="id" label="ID" disabled />
      <TextInput source="name" label="Packaging Reference" />
      <TextInput source="createdAt" label="Created at" disabled />
      <TextInput source="updatedAt" label="Updated at" disabled />
    </SimpleForm>
  </Edit>
);

const retailPackagingResource = () => (
  <Resource
    name="retailPackaging"
    options={{ label: "Historical Retail Packaging", menuGroup: "Packaging" }}
    list={RetailPackagingList}
    edit={EditRetailPackaging}
    show={ShowRetailPackaging}
  />
);

export default retailPackagingResource;
